module.exports = __webpack_public_path__ + "static/media/commercial-safes.f35d5953.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/commercial-safes.png
// module id = 1281
// module chunks = 0